import type { PostHogInterface } from "posthog-js";

export type MoreDogsSurface = "family_row" | "gallery_end" | "other_dogs_grid";

type MoreDogsClicked =
    | {
          kind: "dog";
          surface: MoreDogsSurface;
          position: number;
          sourceListingId: string;
          targetListingId: string;
      }
    | { kind: "see_all"; surface: MoreDogsSurface; sourceListingId: string };

export function captureMoreDogsClicked(
    posthog: PostHogInterface | undefined,
    event: MoreDogsClicked,
) {
    posthog?.capture("listing_more_dogs_clicked", event);
}
